<template>
  <v-sheet outlined style="border-radius: 8px" class="pb-2" height="610">
    <v-sheet
      style="border-top-right-radius: 8px; border-top-left-radius: 8px"
      class="py-1"
      color="secondary"
    >
      <p class="white--text text-center text-h4 ma-0 pt-3">
        {{ plan == "grow" ? "Grow" : "Evolve" }}
      </p>
      <p class="white--text text-center text-h6">
        {{ plan == "grow" ? "For Business" : "For Business + Events" }}
      </p>
    </v-sheet>
    <v-sheet class="py-1 mb-2" color="grey lighten-4">
      <p class="text-center ma-0 pt-3">
        <span class="text-h4">${{ basePrice }}</span>
        <span>/{{ isYearly ? "year" : "month" }}</span>
      </p>
      <p class="text-center text-body-2">
        + ${{ pricePerCard }}/{{ isYearly ? "year" : "month" }}/additional team
        member
      </p>
    </v-sheet>
    <v-list dense>
      <v-list-item
        v-for="(feature, index) in primaryFeatures"
        :key="`primaryFeature-${index}`"
      >
        <v-list-item-icon>
          <v-icon size="20" color="primary">mdi-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-subtitle-2 font-weight-regular">
            {{ feature }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-subtitle-2 font-weight-regular">
            <a :href="pricingUrl" target="_blank" rel="noopener noreferrer"
              >View All Inclusions</a
            >
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <p v-if="plan == 'evolve'" class="px-2" style="height: 104px"></p>
    <p class="text-center">
      <slot />
    </p>
  </v-sheet>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "PlanContainer",
  props: {
    plan: {
      type: String,
      default: "evolve",
    },
    isYearly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["pricingUrl"]),
    primaryFeatures() {
      if (this.plan == "grow")
        return [
          "Double-sided (animated) brandable card template",
          "Unlimited contact details & links to socials",
          "Unlimited connections for every team member",
          "Business Portal for team management",
          "Volume discounts for larger team sizes",
          "Dual-ownership of connections",
          "Priority Support",
        ];
      else
        return [
          "All Grow Inclusions",
          "EventConnect",
          "Business Card Prize Draws",
          "Promotions for all your events",
          // 'Double-sided (animated) brandable card template',
          // 'Unlimited contact details & links to socials',
          // 'Unlimited connections for every team member',
          // 'Business Portal for team management',
        ];
    },
    basePrice() {
      if (this.isYearly) {
        if (this.plan == "grow") return 191.52;
        else return 287.52;
      } else {
        if (this.plan == "grow") return 19.95;
        else return 29.95;
      }
    },
    pricePerCard() {
      if (this.isYearly) return 28.8;
      else return 3;
    },
  },
};
</script>
